export default {
  textColor: {
    color: '#ffffff',
  },
};
